import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';

import { formatNumberToThousands, formatReportRange } from "~/utils/utils";
import { useTrans } from '~/hooks/useTrans';
import { IReportItem } from "~/providers/interfaces";
import Loader from '~/components/Loader';
import { useLang } from "~/hooks/useLang";

export type TReportsTableShowData = "projects" | "call" | "amount";

interface IAdminReportsTable {
	loading: boolean;
	items: Array<IReportItem>;
	showData?: (type: TReportsTableShowData, report: IReportItem) => void;
}

export default function AdminReportsTable({
	loading = true,
	items = [],
	showData = () => {},
}: IAdminReportsTable) {
	const { trans, formatPennyPrice, formatCredits } = useTrans();
	const { isCzech } = useLang();
	// neni nutne cpat do prekladu, pouzito na 1 miste
	const HEADER = [
		"Období",
		"Počet projektů",
		"Nových projektů",
		"Volání",
		"Spotřebovaných kreditů",
		"Placených kreditů",
		"Volných kreditů",
		"Placená částka",
	];

	/* eslint-disable react/no-array-index-key */
	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADER.map(header => <TableCell sx={{ fontWeight: "bold" }} className="text-align-center" key={header}>
						{ header && trans(header) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ items.map((report, ind) => (<TableRow key={ind}>
					<TableCell className="text-align-center">
						{ formatReportRange(report, isCzech) }
					</TableCell>
					<TableCell className="text-align-center">
						<Button color="success" variant="outlined" onClick={() => showData("projects", report)} style={{ whiteSpace: "nowrap" }}>
							{ formatNumberToThousands(report.projectsWithConsumption) }
						</Button>
					</TableCell>
					<TableCell className="text-align-center">
						{ formatNumberToThousands(report.newProjectCount) }
					</TableCell>
					<TableCell className="text-align-center">
						<Button color="success" variant="outlined" onClick={() => showData("call", report)} style={{ whiteSpace: "nowrap" }}>
							{ formatNumberToThousands(report.totalResourceCalls) }
						</Button>
					</TableCell>
					<TableCell className="text-align-center">
						{ formatCredits(report.totalConsumedCredits) }
					</TableCell>
					<TableCell className="text-align-center">
						{ formatCredits(report.creditsCharged) }
					</TableCell>
					<TableCell className="text-align-center">
						{ formatCredits(report.creditsFreeOfCharge) }
					</TableCell>
					<TableCell className="text-align-center">
						<Button color="success" variant="outlined" onClick={() => showData("amount", report)} style={{ whiteSpace: "nowrap" }}>
							{ formatPennyPrice(report.amountTotal) }
						</Button>
					</TableCell>
				</TableRow>)) }
				{ items.length === 0 && <TableRow>
					<TableCell colSpan={HEADER.length} className="text-align-center">
						{ loading && <Loader msg={trans("loadingData")} /> }
						{ !loading && trans("emptyTable") }
					</TableCell>
				</TableRow> }
			</TableBody>
		</Table>
	</TableContainer>;
}
